import { render, staticRenderFns } from "./AdminEditAdsDialog.vue?vue&type=template&id=cebd07ba"
import script from "./AdminEditAdsDialog.vue?vue&type=script&lang=js"
export * from "./AdminEditAdsDialog.vue?vue&type=script&lang=js"
import style0 from "./AdminEditAdsDialog.vue?vue&type=style&index=0&id=cebd07ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports